import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientsWithSamePropertyQuery, ClientWithSamePropertyQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientsWithSamePropertyQuery)
@Wrapper(ClientWithSamePropertyQueryHandlerBase)
export class ClientsWithSamePropertyQueryHandler {
    public constructor(
        http: Http
    ) { }
}
